<script>
    export let title;
    export let description;
    export let url;
    export let img;
</script>

<div class="card">
    <div class="bg-img">
        <a href={url}><img src={img} alt={description} /></a>
    </div>
    <div class="content">
        <a href={url}><h3>{title}</h3></a>
        <p>{description}</p>
    </div>
</div>

<style>
    .card {
        border: 1.5px solid #a4a4a4;
        border-radius: 0.1rem;
    }

    .bg-img {
        background-size: cover;
        min-height: 175px;
        background-position: center;
        background-color: #f9f9f9;
    }

    .content {
        padding: 15px;
    }

    img {
        max-height: 100%;
        max-width: 100%;
        border-radius: 0.1rem;
        -webkit-filter: grayscale(20%);
        filter: grayscale(20%);
    }

    img:hover {
        -webkit-filter: grayscale(0%);
        filter: grayscale(0%);
    }

    h3 {
        display: inline-block;
        text-decoration: underline;
        text-decoration-color: #d11349;
        margin-bottom: 0px;
        color: #3e454f;
    }

    a:hover h3 {
        color: #d11349;
    }
</style>